// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-big-calendar/lib/css/react-big-calendar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-big-calendar/lib/addons/dragAndDrop/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours are driven by CSS variables set from the MUI theme in CalendarPaper,
   with sensible fallbacks so the stylesheet still renders in isolation. */

.rbc-calendar {
  border-radius: 18px;
  font-family: inherit;
}

.rbc-calendar tr {
  display: flex;
}

.rbc-month-view .rbc-time-view,
.rbc-agenda-view {
  background: inherit;
}

.rbc-day-bg:hover {
  cursor: pointer;
  background-color: var(--rbc-hover-bg, rgba(29, 91, 157, 0.08));
}

/* Header */
.rbc-header {
  min-height: 40px;
  font-weight: 400;
  color: var(--rbc-header-color, #5a5a5a);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  padding: 8px;
  font-size: 0.8rem;
}

.rbc-header + .rbc-header {
  border-left: unset;
}

/* Unify every structural grid border with the theme divider for consistency */
.rbc-time-view,
.rbc-month-view,
.rbc-header,
.rbc-day-bg + .rbc-day-bg,
.rbc-month-row + .rbc-month-row,
.rbc-time-content,
.rbc-time-content > * + * > *,
.rbc-timeslot-group,
.rbc-time-header-content,
.rbc-time-header.rbc-overflowing,
.rbc-time-header-content > .rbc-row.rbc-row-resource,
.rbc-day-slot .rbc-time-slot {
  border-color: var(--rbc-border, rgba(0, 0, 0, 0.12));
}

/* Month view: keep days outside the current month subtle and readable
   instead of the heavy default grey block */
.rbc-off-range-bg {
  background: var(--rbc-offrange-bg, rgba(0, 0, 0, 0.02));
}

.rbc-off-range {
  color: var(--rbc-offrange-color, #9aa0a6);
}

.rbc-toolbar {
  min-height: 40px;
}

.rbc-toolbar-label {
  color: var(--rbc-primary, #1d5b9d);
  font-size: 1rem;
}

/* Current day */
.rbc-day-bg.rbc-today {
  border-top: 4px solid var(--rbc-primary, #1d5b9d);
}

.rbc-date-cell.rbc-now {
  color: var(--rbc-primary, #1d5b9d);
}

.rbc-today {
  background-color: var(--rbc-today-bg, rgba(29, 91, 157, 0.06));
}

.rbc-button-link {
  padding: 8px;
  font-size: 0.75rem;
  font-family: inherit;
}

/* Time slot grid lines */
.rbc-calendar-light .rbc-day-slot .rbc-time-slot {
  border-top: 1px solid var(--rbc-grid-line, #f7f7f7);
}

.rbc-calendar-dark .rbc-day-slot .rbc-time-slot {
  border-top: 1px solid var(--rbc-grid-line, #2a2a2a);
}

/* Events */
.rbc-event {
  transition:
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.rbc-event:hover {
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.2);
}

.rbc-event:focus {
  outline: 2px solid var(--rbc-primary, #1d5b9d);
  outline-offset: 1px;
}

/* Time-grid (day / week) events: always keep the customer name readable, even
   for short recalls. The default time label is hidden because the grid row and
   the details dialog already convey the time. */
.rbc-day-slot .rbc-event {
  min-height: 30px;
  display: flex;
  align-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
}

.rbc-day-slot .rbc-event-label {
  display: none;
}

.rbc-day-slot .rbc-event-content {
  width: 100%;
  min-width: 0;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/calendar-custom.scss"],"names":[],"mappings":"AAGA;0EAC0E;;AAE1E;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8DAA8D;AAChE;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;;;;;;;;;;;;EAYE,oDAAoD;AACtD;;AAEA;4CAC4C;AAC5C;EACE,uDAAuD;AACzD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,WAAW;AACX;EACE;;uBAEqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;;gDAEgD;AAChD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["@import 'react-big-calendar/lib/css/react-big-calendar.css';\n@import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';\n\n/* Colours are driven by CSS variables set from the MUI theme in CalendarPaper,\n   with sensible fallbacks so the stylesheet still renders in isolation. */\n\n.rbc-calendar {\n  border-radius: 18px;\n  font-family: inherit;\n}\n\n.rbc-calendar tr {\n  display: flex;\n}\n\n.rbc-month-view .rbc-time-view,\n.rbc-agenda-view {\n  background: inherit;\n}\n\n.rbc-day-bg:hover {\n  cursor: pointer;\n  background-color: var(--rbc-hover-bg, rgba(29, 91, 157, 0.08));\n}\n\n/* Header */\n.rbc-header {\n  min-height: 40px;\n  font-weight: 400;\n  color: var(--rbc-header-color, #5a5a5a);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  text-align: left;\n  padding: 8px;\n  font-size: 0.8rem;\n}\n\n.rbc-header + .rbc-header {\n  border-left: unset;\n}\n\n/* Unify every structural grid border with the theme divider for consistency */\n.rbc-time-view,\n.rbc-month-view,\n.rbc-header,\n.rbc-day-bg + .rbc-day-bg,\n.rbc-month-row + .rbc-month-row,\n.rbc-time-content,\n.rbc-time-content > * + * > *,\n.rbc-timeslot-group,\n.rbc-time-header-content,\n.rbc-time-header.rbc-overflowing,\n.rbc-time-header-content > .rbc-row.rbc-row-resource,\n.rbc-day-slot .rbc-time-slot {\n  border-color: var(--rbc-border, rgba(0, 0, 0, 0.12));\n}\n\n/* Month view: keep days outside the current month subtle and readable\n   instead of the heavy default grey block */\n.rbc-off-range-bg {\n  background: var(--rbc-offrange-bg, rgba(0, 0, 0, 0.02));\n}\n\n.rbc-off-range {\n  color: var(--rbc-offrange-color, #9aa0a6);\n}\n\n.rbc-toolbar {\n  min-height: 40px;\n}\n\n.rbc-toolbar-label {\n  color: var(--rbc-primary, #1d5b9d);\n  font-size: 1rem;\n}\n\n/* Current day */\n.rbc-day-bg.rbc-today {\n  border-top: 4px solid var(--rbc-primary, #1d5b9d);\n}\n\n.rbc-date-cell.rbc-now {\n  color: var(--rbc-primary, #1d5b9d);\n}\n\n.rbc-today {\n  background-color: var(--rbc-today-bg, rgba(29, 91, 157, 0.06));\n}\n\n.rbc-button-link {\n  padding: 8px;\n  font-size: 0.75rem;\n  font-family: inherit;\n}\n\n/* Time slot grid lines */\n.rbc-calendar-light .rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid var(--rbc-grid-line, #f7f7f7);\n}\n\n.rbc-calendar-dark .rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid var(--rbc-grid-line, #2a2a2a);\n}\n\n/* Events */\n.rbc-event {\n  transition:\n    box-shadow 0.2s ease,\n    transform 0.2s ease;\n}\n\n.rbc-event:hover {\n  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.rbc-event:focus {\n  outline: 2px solid var(--rbc-primary, #1d5b9d);\n  outline-offset: 1px;\n}\n\n/* Time-grid (day / week) events: always keep the customer name readable, even\n   for short recalls. The default time label is hidden because the grid row and\n   the details dialog already convey the time. */\n.rbc-day-slot .rbc-event {\n  min-height: 30px;\n  display: flex;\n  align-items: center;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.rbc-day-slot .rbc-event-label {\n  display: none;\n}\n\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
